import { Fragment } from "react"
import { toast } from "react-toastify"
import Avatar from "@components/avatar"
import { Bell } from "react-feather"
import { useIntl } from "react-intl"

const Notification = ({ data, toastId }) => {
  const intl = useIntl()
  let message = ""

  if (data?.error) {
    if (data.error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const errorData = data.error.response.data
      if (errorData.detail) {
        if (Array.isArray(errorData.detail)) {
          errorData.detail.map((obj) => {
            const key = Object.keys(obj)[0]
            const value = obj[key]
            message = `${message}\n${key}: ${value}`
          })
        } else if (typeof errorData.detail === "object") {
          const key = Object.keys(errorData.detail)[0]
          const value = errorData.detail[key]
          message = `${key}: ${value}`
        } else {
          message = errorData.detail
        }
      } else {
        message = `${errorData.message ? errorData.message : errorData.error ? errorData.error : ""}`
      }
    } else if (data.error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      message = data.error.request
    } else {
      // Something happened in setting up the request that triggered an Error
      message = data.error.message
    }
  }

  return (
    <>
      {data?.info &&
        toast(
          <Fragment>
            <div className="toastify-header">
              <div className="title-wrapper">
                <Avatar size="sm" color="primary" icon={<Bell size={12} />} />
                <h6 className="toast-title">
                  {intl.formatMessage({ id: "info" })}!
                </h6>
              </div>
            </div>
            <div className="toastify-body">
              <span role="img" aria-label="toast-text">
                {data.info}
              </span>
            </div>
          </Fragment>,
          {
            hideProgressBar: true,
            toastId: toastId !== null || toastId !== undefined ? toastId : undefined
          }
        )}

      {data?.success &&
        toast.success(
          <Fragment>
            <div className="toastify-header">
              <div className="title-wrapper">
                <Avatar size="sm" color="success" icon={<Bell size={12} />} />
                <h6 className="toast-title">
                  {intl.formatMessage({ id: "success" })}!
                </h6>
              </div>
            </div>
            <div className="toastify-body">
              <span role="img" aria-label="toast-text">
                {data.success}
              </span>
            </div>
          </Fragment>,
          {
            hideProgressBar: true,
            toastId: toastId !== null || toastId !== undefined ? toastId : undefined
          }
        )}

      {message &&
        toast.error(
          <Fragment>
            <div className="toastify-header">
              <div className="title-wrapper">
                <Avatar size="sm" color="danger" icon={<Bell size={12} />} />
                <h6 className="toast-title">
                  {intl.formatMessage({ id: "error" })}!
                </h6>
              </div>
            </div>
            <div className="toastify-body">
              <span role="img" aria-label="toast-text">
                {message}
              </span>
            </div>
          </Fragment>,
          {
            hideProgressBar: true,
            toastId: toastId !== null || toastId !== undefined ? toastId : undefined
          }
        )}

      {data?.warning &&
        toast.warning(
          <Fragment>
            <div className="toastify-header">
              <div className="title-wrapper">
                <Avatar size="sm" color="warning" icon={<Bell size={12} />} />
                <h6 className="toast-title">
                  {intl.formatMessage({ id: "warning" })}!
                </h6>
              </div>
            </div>
            <div className="toastify-body">
              <span role="img" aria-label="toast-text">
                {data.warning}
              </span>
            </div>
          </Fragment>,
          {
            hideProgressBar: true,
            toastId: toastId !== null || toastId !== undefined ? toastId : undefined
          }
        )}
    </>
  )
}

export default Notification
